import { useEffect, useState } from 'react';
import { MdCheck } from 'react-icons/md';
import api from '../../../../services/api';

import { PrimaryButton } from '../../atoms/PrimaryButton/PrimaryButton';
import { SecondaryButton } from '../../atoms/SecondaryButton/SecondaryButton';
import { Container } from './_planOffers';

export const PlanOffers = ({ showButton, greenBackground }) => {
  const [plans, setPlans] = useState([{ id: '', name: '', price: 0 }]);

  const loadPlans = async () => {
    try {
      const response = await api.get('/plan-types?isVisible=true');
      setPlans(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    loadPlans();
  }, []);

  const formatStringCurrency = (value) => {
    const parsedValue = parseFloat(value);

    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format;

    return formatter(parsedValue);
  };

  const onTimePeriod = (name) => {
    return name === 'Plano Anual' ? '/ano' : '/mês';
  };

  return (
    <Container
      className={`plan-offers ${
        greenBackground && 'plan-offers--green-background'
      }`}
    >
      <h2 className="plan-offers__title">Escolha seu pacote</h2>

      <span className="plan-offers__call-to-action">
        O pacote que cabe no seu bolso totalmente disponível para você.
      </span>

      <div className="plan-offers__cards-wrapper">
        {plans.map(userPlan => (
          <div className="plan-offers__plan-card">
            <div className="plan-offers__price">
              <span className="plan-offers__price-value">
                {formatStringCurrency(userPlan.price)}
                <small className="plan-offers__small"> {onTimePeriod(userPlan.name)}</small>
              </span>
              <div className="plan-offers__benefit-container">
                <div className="plan-offers__benefit">
                  <MdCheck />
                  <p>Tenha acesso ilimitado ao App</p>
                </div>
                <div className="plan-offers__benefit">
                  <MdCheck />
                  <p>Aprenda no seu tempo</p>
                </div>
                <div className="plan-offers__benefit">
                  <MdCheck />
                  <p>Se desenvolva com qualidade</p>
                </div>
              </div>
            </div>

            <div className="plan-offers__plan-name">
              <small>Plano</small>
              {userPlan.name.replace('Plano ', "")}
            </div>
          </div>
        ))}
      
        {/* 
        <div className="plan-offers__plan-card plan-offers__plan-card--yearly">
          <div className="plan-offers__price plan-offers__price--yearly">
            <span>
              R$ 479,90
              <small className="plan-offers__small"> /ano</small>
            </span>
          </div>
          <div className="plan-offers__plan-name">
            <small>Plano</small>
            anual
          </div>

          <div className="plan-offers__advantage-tag">
            <span>Menos de</span> R$ 40 por mês
            <small>O melhor custo benefício</small>
          </div> */}
        {/* {/* </div> } */}
      </div>

      {/* <p className="plan-offers__paragraph">
        Aqui você pode escolher qual plano fica melhor para você. Todas as
        opções podem ser trocadas a qualquer momento e nós resolvemos isso para
        você.
      </p> */}

      {showButton && greenBackground && (
        <PrimaryButton href={'escolha-um-plano'}>
          Experimente grátis por 7 dias
        </PrimaryButton>
      )}

      {showButton && !greenBackground && (
        <SecondaryButton href={'escolha-um-plano'}>
          Experimente grátis por 7 dias
        </SecondaryButton>
      )}

      {!showButton && <span className="plan-offers__invite">Vamos?</span>}
    </Container>
  );
};
